<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-6 col-xl-6">
                <edit-profile-form/>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-6">
                <edit-billing-form/>
            </div>
        </div>
        <div class="row">
<!--            <div class="col-sm-12 col-lg-8 col-xl-6">-->
<!--                <credit-card-form/>-->
<!--            </div>-->
            <div class="col-sm-12 col-lg-4 col-xl-6">
                <mollie-connect-form/>
            </div>
        </div>
    </div>

</template>
<script>
    import EditProfileForm from "../Profile/EditUserProfileForm";
    import EditBillingForm from "../Profile/EditBillingProfileForm";
    import MollieConnectForm from "../Profile/MollieConnectForm";

    export default {
        components: {
            EditProfileForm,
            EditBillingForm,
            MollieConnectForm
        }
    };
</script>
<style/>
